import { projectActivityLine } from "../hours/projectActivityDisplay";
import {
  buildActivityGroupSections,
  hasRealActivityGroups,
} from "../../utils/moduleSelectors/projectActivityGroupUtils";

export function sumHours(entries) {
  return (entries || []).reduce(
    (sum, entry) => sum + (parseFloat(entry.time) || 0),
    0
  );
}

export function isHourApproved(entry) {
  return Boolean(entry?.approved);
}

export function unapprovedEntries(entries) {
  return (entries || []).filter((entry) => !isHourApproved(entry));
}

export function enrichHourWithActivity(entry, activitiesById) {
  if (!entry) return entry;
  const paId = entry.project_activity_id ?? entry.project_activity?.id;
  const fromList = paId != null ? activitiesById.get(String(paId)) : null;
  if (!fromList) return entry;
  const existing = entry.project_activity || {};
  return {
    ...entry,
    project_activity: {
      ...fromList,
      ...existing,
      group_id:
        existing.group_id ??
        existing.groupId ??
        existing.group?.id ??
        fromList.group_id ??
        fromList.groupId ??
        fromList.group?.id ??
        null,
      group: existing.group || fromList.group || null,
    },
  };
}

function activityFromEntry(entry, noActivityLabel) {
  const pa = entry?.project_activity;
  const line = projectActivityLine(pa);
  if (pa?.id != null || entry?.project_activity_id != null) {
    const id = pa?.id ?? entry.project_activity_id;
    return {
      id,
      title: line || `#${id}`,
      display_title: line || `#${id}`,
      group_id: pa?.group_id ?? pa?.groupId ?? pa?.group?.id ?? null,
      group: pa?.group || null,
      row_order: pa?.row_order ?? pa?.rowOrder ?? 0,
    };
  }
  return {
    id: "__none__",
    title: noActivityLabel,
    display_title: noActivityLabel,
    group_id: null,
    group: null,
    row_order: Number.MAX_SAFE_INTEGER,
  };
}

/**
 * Group hour entries by aktivitetsgruppe, then by activity — same sections as
 * ModernProjectActivitySelector / GroupedActivityOptions.
 */
export function buildHourActivityGroupSections(
  entries,
  groups,
  { noActivityLabel = "", ungroupedLabel = "" } = {}
) {
  const hoursByActivity = new Map();
  const activities = [];

  for (const entry of entries || []) {
    const act = activityFromEntry(entry, noActivityLabel);
    const key = String(act.id);
    if (!hoursByActivity.has(key)) {
      hoursByActivity.set(key, []);
      activities.push(act);
    }
    hoursByActivity.get(key).push(entry);
  }

  const sections = buildActivityGroupSections(activities, groups, {
    ungroupedLabel,
    hideEmptyGroups: true,
  });

  return sections.map((section) => ({
    ...section,
    activities: section.activities.map((act) => {
      const list = hoursByActivity.get(String(act.id)) || [];
      return {
        ...act,
        entries: list,
        totalHours: sumHours(list),
      };
    }),
  }));
}

export function hourSectionsHaveGroups(sections, groups) {
  const activities = (sections || []).flatMap((s) => s.activities || []);
  return hasRealActivityGroups(activities, groups);
}
